import React, { useState } from "react";
import Avatar from "../../../assets/AvatarProfile.png";
import ManagerUserProfilePersonalInfo from "./ManagerUserProfilePersonalInfo";
import ManagerUserProfilePrivacy from "./ManagerUserProfilePrivacy";
import ManagerUserProfileNotfications from "./ManagerUserProfileNotfications";
import ManagerUserProfileReportsPreferences from "./ManagerUserProfileReportsPreferences";

function ManagerUserProfileMain() {
  const [state, setState] = useState("personal info");

  return (
    <div className="">
      <section className="w-full relative pb-36">
        <div className="w-full h-54 bg-linear-to-r from-sky-300 to-white"></div>
        <div className="absolute top-[160px] pl-10 flex justify-between items-center w-full">
          <div className="flex  items-center justify-start ">
            <div className="flex justify-center items-center relative">
              <img
                src={Avatar}
                alt=""
                className="md:w-44 md:h-44 sm:w-36 sm:h-36 max-[420px]:h-24 max-[420px]:w-24 h-36  w-36 "
              />
              <div className="absolute md:bottom-[24px] sm:bottom-[18px] max-[420px]:bottom-[10px] max-[420px]:right-[12px] w-[32px] h-[32px] max-[420px]:h-[20px] max-[420px]:w-[20px]  bottom-[15px] right-[24px] ">
                <svg
                  // width="32"
                  // height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_1330_4937)">
                    <path
                      d="M24.7109 5.66812C25.0149 6.40315 25.5982 6.9874 26.3328 7.29243L28.9086 8.35935C29.6437 8.66383 30.2277 9.24785 30.5322 9.98294C30.8366 10.718 30.8366 11.544 30.5322 12.279L29.466 14.853C29.1614 15.5884 29.161 16.4151 29.467 17.1502L30.5313 19.7234C30.6822 20.0874 30.7599 20.4777 30.76 20.8718C30.7601 21.266 30.6825 21.6562 30.5316 22.0204C30.3808 22.3845 30.1597 22.7153 29.881 22.994C29.6022 23.2726 29.2713 23.4936 28.9072 23.6443L26.3332 24.7105C25.5982 25.0144 25.014 25.5978 24.7089 26.3323L23.642 28.9081C23.3375 29.6432 22.7535 30.2272 22.0184 30.5317C21.2833 30.8362 20.4574 30.8362 19.7223 30.5317L17.1484 29.4655C16.4133 29.1618 15.5877 29.1624 14.853 29.4673L12.2772 30.5327C11.5426 30.8364 10.7173 30.8362 9.98286 30.5319C9.24837 30.2277 8.66467 29.6444 8.35998 28.9101L7.29274 26.3335C6.98882 25.5985 6.40545 25.0143 5.67088 24.7092L3.09511 23.6423C2.36034 23.338 1.77649 22.7543 1.4719 22.0196C1.1673 21.285 1.16689 20.4594 1.47075 19.7245L2.53691 17.1505C2.84064 16.4154 2.84002 15.5898 2.53518 14.8552L1.47056 12.2775C1.31961 11.9135 1.24189 11.5232 1.24183 11.1291C1.24176 10.7349 1.31936 10.3447 1.47019 9.98054C1.62101 9.61641 1.84211 9.28558 2.12085 9.00693C2.39958 8.72828 2.73049 8.50729 3.09466 8.35658L5.66859 7.29043C6.40298 6.98677 6.98688 6.40414 7.29213 5.67041L8.35905 3.09464C8.66354 2.35955 9.24756 1.77553 9.98264 1.47105C10.7177 1.16657 11.5437 1.16657 12.2787 1.47105L14.8527 2.5372C15.5878 2.84094 16.4134 2.84032 17.1481 2.53548L19.7249 1.4727C20.4599 1.16839 21.2857 1.16845 22.0206 1.47287C22.7555 1.7773 23.3395 2.36115 23.644 3.09604L24.7113 5.67259L24.7109 5.66812Z"
                      fill="#2E90FA"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M22.2665 11.8068C22.4803 11.471 22.5519 11.0641 22.4656 10.6755C22.3794 10.287 22.1423 9.94857 21.8065 9.7348C21.4708 9.52104 21.0638 9.44941 20.6753 9.53568C20.2867 9.62194 19.9483 9.85904 19.7345 10.1948L13.8605 19.4248L11.1725 16.0648C10.924 15.754 10.5622 15.5546 10.1667 15.5105C9.77118 15.4664 9.37436 15.5813 9.06352 15.8298C8.75269 16.0783 8.55331 16.4401 8.50923 16.8356C8.46516 17.2311 8.58001 17.628 8.82852 17.9388L12.8285 22.9388C12.9776 23.1254 13.1691 23.2737 13.387 23.3713C13.6049 23.469 13.843 23.5132 14.0815 23.5003C14.32 23.4874 14.5519 23.4177 14.758 23.2971C14.9641 23.1765 15.1385 23.0084 15.2665 22.8068L22.2665 11.8068Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1330_4937">
                      <rect width="32" height="32" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>

            <div className=" flex justify-start flex-col gap-1">
              <p className=" text-[#181D27] md:text-2xl sm:text-lg text-sm  font-semibold">
                Olivia Rhye
              </p>
              <p className=" text-[#535862] md:text-lg sm:text-sm text-xs ">
                olivia@aiaura.com
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="flex flex-col gap-10">
        <div className="w-full flex lg:flex-nowrap flex-wrap items-center gap-6">
          <button
            className={` ${
              state === "personal info"
                ? "text-[#009C97] bg-[#F5FFFD]"
                : "text-gray-700"
            }  rounded-sm px-3 py-1 cursor-pointer text-sm font-semibold`}
            onClick={() => setState("personal info")}
          >
            Personal Info
          </button>
          <button
            className={` ${
              state === "reports preferences"
                ? "text-[#009C97] bg-[#F5FFFD]"
                : "text-gray-700"
            }  rounded-sm px-3 py-1 cursor-pointer text-sm font-semibold`}
            onClick={() => setState("reports preferences")}
          >
            Reports Preferences
          </button>
          <button
            className={` ${
              state === "notfications"
                ? "text-[#009C97] bg-[#F5FFFD]"
                : "text-gray-700"
            }  rounded-sm px-3 py-1 cursor-pointer text-sm font-semibold`}
            onClick={() => setState("notfications")}
          >
            Notifications
          </button>{" "}
          <button
            className={` ${
              state === "privacy"
                ? "text-[#009C97] bg-[#F5FFFD]"
                : "text-gray-700"
            }  rounded-sm px-3 py-1 cursor-pointer text-sm font-semibold`}
            onClick={() => setState("privacy")}
          >
            Privacy
          </button>
        </div>

        <div>
          {state === "personal info" ? (
            <ManagerUserProfilePersonalInfo />
          ) : state === "reports preferences" ? (
            <ManagerUserProfileReportsPreferences />
          ) : state === "notfications" ? (
            <ManagerUserProfileNotfications />
          ) : state === "privacy" ? (
            <ManagerUserProfilePrivacy />
          ) : null}
        </div>
      </section>
    </div>
  );
}

export default ManagerUserProfileMain;
